import {
  FETCH_IMPORTED_INVENTORY_REQUEST,
  FETCH_IMPORTED_INVENTORY_SUCCESS,
  FETCH_IMPORTED_INVENTORY_FAILURE,
  UPLOAD_CSV_REQUEST,
  UPLOAD_CSV_SUCCESS,
  UPLOAD_CSV_FAILURE,
  UPDATE_IMPORTED_INVENTORY_REQUEST,
  UPDATE_IMPORTED_INVENTORY_SUCCESS,
  UPDATE_IMPORTED_INVENTORY_FAILURE,
  DELETE_IMPORTED_INVENTORY_REQUEST,
  DELETE_IMPORTED_INVENTORY_SUCCESS,
  DELETE_IMPORTED_INVENTORY_FAILURE,
  DELETE_ALL_IMPORTED_INVENTORY_REQUEST,
  DELETE_ALL_IMPORTED_INVENTORY_SUCCESS,
  DELETE_ALL_IMPORTED_INVENTORY_FAILURE
} from '../../types/importedInventory/importedInventoryTypes';
import axios from 'axios';
import store from '../../store'; // Import the Redux store to access the current user

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE_URL}/api/imported-inventory`;


// Thunk Actions
export const uploadCsv = (file) => async (dispatch) => {
  try {
    dispatch({ type: UPLOAD_CSV_REQUEST });
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(API_URL + '/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    });
    
    // The backend already creates the CSV import log, so we just need to handle the response
    if (response.data.message) {
      dispatch({
        type: UPLOAD_CSV_SUCCESS,
        payload: {
          success: true,
          message: response.data.message,
          data: response.data.data,
          totalRecords: response.data.data?.totalProcessed || 0,
          savedRecords: response.data.data?.inserted || 0,
          notSavedRecords: response.data.data?.duplicates || 0,
          referenceNumber: response.data.data?.reference_number
        }
      });
      
      // Return the result without automatically fetching data
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
        totalRecords: response.data.data?.totalProcessed || 0,
        savedRecords: response.data.data?.inserted || 0,
        notSavedRecords: response.data.data?.duplicates || 0,
        referenceNumber: response.data.data?.reference_number
      };
    } else {
      throw new Error(response.data.message || 'Upload failed');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to upload CSV file';
    dispatch({
      type: UPLOAD_CSV_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

export const fetchImportedInventory = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_IMPORTED_INVENTORY_REQUEST });
    // Use the updated API call
    const response = await axios.get(`${API_URL}${(startDate || endDate) ? `?${[
      startDate ? `startDate=${encodeURIComponent(startDate)}` : '',
      endDate ? `endDate=${encodeURIComponent(endDate)}` : ''
    ].filter(Boolean).join('&')}` : ''}`, {
      withCredentials: true
    });
    dispatch({
      type: FETCH_IMPORTED_INVENTORY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_IMPORTED_INVENTORY_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch imported inventory'
    });
    throw error;
  }
};

export const updateImportedInventory = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_IMPORTED_INVENTORY_REQUEST });
    const response = await axios.put(API_URL + '/' + id, data, {
      withCredentials: true
    });
    
    if (response.data.success) {
      dispatch({
        type: UPDATE_IMPORTED_INVENTORY_SUCCESS,
        payload: response.data
      });
      
      // Refresh the imported inventory list after successful update
      await dispatch(fetchImportedInventory());
      return response.data;
    } else {
      throw new Error(response.data.message || 'Update failed');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update record';
    dispatch({
      type: UPDATE_IMPORTED_INVENTORY_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

export const deleteImportedInventory = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_IMPORTED_INVENTORY_REQUEST });
    const response = await axios.delete(API_URL + '/' + id, {
      withCredentials: true
    });
    
    if (response.data.success) {
      dispatch({
        type: DELETE_IMPORTED_INVENTORY_SUCCESS,
        payload: response.data
      });
      
      // Refresh the imported inventory list after successful delete
      await dispatch(fetchImportedInventory());
      return response.data;
    } else {
      throw new Error(response.data.message || 'Delete failed');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete record';
    dispatch({
      type: DELETE_IMPORTED_INVENTORY_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

export const deleteAllImportedInventory = () => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ALL_IMPORTED_INVENTORY_REQUEST });
    const username = store.getState().login.user?.username;
    const response = await axios.delete(API_URL, {
      headers: {
        'x-user-username': username
      },
      withCredentials: true
    });
    
    if (response.data.success) {
      dispatch({
        type: DELETE_ALL_IMPORTED_INVENTORY_SUCCESS,
        payload: response.data
      });
      // Refresh the imported inventory list after successful delete all
      await dispatch(fetchImportedInventory());
      return response.data;
    } else {
      throw new Error(response.data.message || 'Delete all failed');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete all records';
    dispatch({
      type: DELETE_ALL_IMPORTED_INVENTORY_FAILURE,
      payload: errorMessage
    });
    throw new Error(errorMessage);
  }
};

export const deleteImportedInventoryByReference = (referenceNumber) => async (dispatch) => {
  const username = store.getState().login.user?.username;
  const response = await axios.delete(`${API_URL}/reference/${referenceNumber}`, {
    headers: { 'x-user-username': username },
    withCredentials: true
  });
  // Optionally, dispatch a refresh or success action here
  await dispatch(fetchImportedInventory());
  return response.data;
};